import { OracleInstaller } from "./types";

export const loginInstaller: OracleInstaller["iam-write"]["items"]["login"] = {
  options: {
    iam: { items: {} },
  },
};

export const iamWriteInstructions: OracleInstaller["iam-write"]["instructions"] =
  () => {
    return {
      help: (
        <>
          To install P0 on this account, provision P0&apos;s access using
          Terraform:
        </>
      ),
      commands: {
        shell: [],
        iac: [],
      },
    };
  };

export const oracleIamWriteInstaller: OracleInstaller["iam-write"] = {
  instructions: iamWriteInstructions,
  items: {
    login: loginInstaller,
  },
};

export const oracleInstaller = (): OracleInstaller => {
  return {
    "iam-write": oracleIamWriteInstaller,
  };
};
